import { useState, useEffect } from 'react';
import { useGetFaqListQuery, useGetFaqContentsListQuery, GetFaqListQuery } from 'views/utils/graphql/graphql';

export const useDataFAQ = (id:number) => {
  const [faqData, setfaqData] = useState<GetFaqListQuery>();

  //全体項目の取得
  const [faqDataList, _] = useGetFaqListQuery({
    variables: {
      page: 1,
      count: 100,
      symbolProductType: id,
    },
    requestPolicy: 'network-only',
  });

  useEffect(() => {
    if (faqDataList.data) {
      setfaqData(faqDataList.data);
    }
  }, [faqDataList.data]);

  return { faqData, setfaqData, faqDataLord: faqDataList.fetching };
};

export const useFAQ = (id:number) => {
  //複数項目useState
  const [openIds, setOpenIds] = useState<number[]>([]);
  //単一項目useState
  const [openId, setOpenId] = useState<number | null>(null);
  const [selectedId, setSelectedId] = useState<number | null>(null);
  const { faqData, setfaqData } = useDataFAQ(id);

  //選択項目の取得
  const [faqContentsList, _] = useGetFaqContentsListQuery({
    variables: {
      page: 1,
      count: 100,
      categoryId: selectedId ?? 0,
      symbolProductType: id,
    },
    requestPolicy: 'network-only',
    pause: selectedId === null,
  });

  //FAQ内容が取得された時にデータを追加
  useEffect(() => {
    if (selectedId !== null && faqContentsList.data?.GetFaqContentsList?.Data && faqData?.GetFaqList?.Data) {
      const updatedFaqData = [...faqData.GetFaqList.Data];
      //selectedIdがfaqData内のＩＤにない場合は-1になる
      const targetIndex = faqData?.GetFaqList?.Data?.findIndex((item) => item?.ID === selectedId);
      //selectedIdがある場合　と　初めてクリックされた箇所であればfaqData内はnullとなる
      if (targetIndex !== -1 && !faqData.GetFaqList.Data[targetIndex]?.QaList) {
        const newItems = faqContentsList.data.GetFaqContentsList.Data ?? [];
        updatedFaqData[targetIndex]!.QaList = [...newItems];

        setfaqData({
          ...faqData,
          GetFaqList: {
            ...faqData.GetFaqList,
            Data: updatedFaqData,
          },
        });
      }
    }
  }, [faqContentsList.data]);

  //選択された項目IDを保持 複数項目表示
  // const stateFAQ = (id: number) => {
  //   const isOpen = openIds.includes(id);
  //   const updated = isOpen ? openIds.filter((openId) => openId !== id) : [...openIds, id];
  //   setOpenIds(updated);

  //   if (!isOpen && !faqData?.GetFaqList?.Data![id - 1]?.QaList) {
  //     setSelectedId(id);
  //   }
  // };

  //単一のみ表示
  const stateFAQ = (id: number) => {
    const isOpen = openId === id;
    const newOpenId = isOpen ? null : id;
    setOpenId(newOpenId);

    if (!isOpen && !faqData?.GetFaqList?.Data?.find((item) => item?.ID === id)?.QaList) {
      setSelectedId(id);
    }
    // 選択された項目が最上位に移動
    setTimeout(() => {
      const el = document.getElementById(`faq-item-${id}`);
      if (el) {
        const scroll = window.scrollY || window.pageYOffset;
        const moveTop = el.getBoundingClientRect().top + scroll;
        window.scrollTo({
          top: moveTop,
          behavior: 'smooth',
        });
      }
    }, 300);
  };

  return { openIds, stateFAQ, faqData, openId, faqContentsListLord: faqContentsList.fetching };
};